const app = getApp()
Component({
  /**
   * 组件的属性列表
   */
  properties: {
    show: {
      type: Boolean,
      value: true
    },
    disabled: {
      type: Boolean,
      value: false
    },
    type: {
      type: String,
      value: 'payment'
    },
    // 主题色
    themeColor: {
      type: String,
      value: '#e83e43'
    },
    // 系统信息
    systemInfo: {
      type: Object,
      value: {
        model: '',
        isIphoneX: false
      }
    }
  },
  /**
   * 组件的初始数据
   */
  data: {
    showWebView: false
  },
  
  /**
   * 组件的方法列表
   */
  methods: {
    onClickKeyBoard (e) {
      const key = e.currentTarget.dataset.key
      // 键盘disabled时，点击确认键无反应
      if (key === 'ok' && this.properties.disabled) return
      if (wx && wx.canIUse('vibrateShort') &&
        !['iPhone 4', 'iPhone 5', 'iPhone 6', 'iPhone 6 Plus'].includes(this.data.systemInfo.model)
      ) {
        // 判断小程序版本支持震动
        // 震动仅在 iPhone 7 / 7 Plus 以上及 Android 机型生效
        wx.vibrateShort({
          success: () => {},
          fail: () => {}
        } as any)
      }
      this.triggerEvent('click', key)
    },
    /**
     * @function 打开品牌推广链接
     */
    onOpenBranding () {
      // wx.uma && wx.uma.trackEvent('recruit_agent')
      this.triggerEvent('click', 'branding')
    }
  }
})
